import React, { useState, useEffect } from 'react';
import { Link, withRouter, useParams } from 'react-router-dom';
import { Form, Button, Spinner, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation, useLazyQuery } from '@apollo/client';
import { GET_CAMPAIGN_SCRIPT_DROPLIST } from '../../../gql/campaign/queries';
import { ADD_CAMPAIGN_DATA } from '../../../gql/campaign/mutation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GET_PROFILE } from '../../../gql/auth/queries';
import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Question from "../../../assets/images/question.svg";
import warningIcon from '../../../assets/images/warningIcon.svg';


function CampaignAutoScript({ history }) {
    const { id } = useParams()
    //eslint-disable-next-line
    const [sellTypeList, setSellTypeList] = useState([]);
    const [sellToList, setSellToList] = useState([]);
    const [reachOutList, setReachOutList] = useState([]);
    const [departmentsList, setDepartmentsList] = useState([]);
    const [businessTypeList, setBusinessTypeList] = useState([]);
    //eslint-disable-next-line
    const [outReachMethods, setOutReachMethodsList] = useState([]);
    const [errorMessage, setErrorMessage] = useState('')
    const [campaignId, setCampaignId] = useState('')
    const [addCampaignDataSuccess, setAddCampaignData] = useState(false)
    const [inputList, setInputList] = useState([{ weHelped: "", results: "", timeLine: "", process: "" }]);
    const [textProvider, setTextProvider] = useState('');
    const [smShow, setSmShow] = useState(false);
    const [getDropDownList] = useLazyQuery(GET_CAMPAIGN_SCRIPT_DROPLIST, {
        onCompleted(data) {
            setSellTypeList(data?.getCampaignScript?.sellType)
            setSellToList(data?.getCampaignScript?.sellTo)
            setReachOutList(data?.getCampaignScript?.reachOut)
            setDepartmentsList(data?.getCampaignScript?.departments)
            setBusinessTypeList(data?.getCampaignScript?.businessType)
            setOutReachMethodsList(data?.getCampaignScript?.outReachMethods)
        }
    })
    const [getProfile, { loading: profileLoading }] = useLazyQuery(GET_PROFILE, {
        onCompleted(data) {
            if (data?.me?.emailProvider == null) {
                history.push('/dashboard')
            }
            setTextProvider(data?.me?.textProvider)
        }
    })
    const [addCampaignData, { loading }] = useMutation(ADD_CAMPAIGN_DATA, {
        onCompleted(data) {
            setAddCampaignData(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    })

    useEffect(() => {
        setCampaignId(id ? id : '')
        getDropDownList()
        getProfile()
        //eslint-disable-next-line
    }, [])
    const outreachMethods = ["Email", "SMS"];

    const handleChange = (e) => {
        const { checked, name } = e.target;
        if (name === 'SMS' && textProvider === null) {
            return toast.error('Connect SMS Provider First.', {
                position: "bottom-right",
                closeOnClick: true,
            })
        }
        if (checked) {
            formik.setFieldValue("outreachMethods", [...formik.values.outreachMethods, name]);
        }
        else {
            formik.setFieldValue("outreachMethods", formik.values.outreachMethods.filter((v) => v !== name));
        }
    };

    function allEqual(arr) {
        const isFalse = arr.includes(false);
        return isFalse
    }

    const formik = useFormik({
        initialValues: {
            whatSell: "",
            whomSell: "",
            reachingOut: "",
            whichDepartment: "",
            businessType: "",
            outreachMethods: ["Email"],
            helpCompanies: "",
            inputList: [],
            prospectsLocation: ""
        },
        validationSchema: Yup.object({
            whatSell: Yup.string()
                .required("Select what you sell"),
            whomSell: Yup.string()
                .required("Select whom you sell"),
            reachingOut: Yup.string()
                .required("Select any one"),
            whichDepartment: Yup.string()
                .required("Select department"),
            businessType: Yup.string()
                .required("Select business type"),
            outreachMethods: Yup.array()
                .required('Field is required'),
            helpCompanies: Yup.string()
                .required("Description required"),
        }),
        // enableReinitialize: true,
        onSubmit: (values) => {
            try {
                if (!campaignId) {
                    return toast.error("Create Campaign Name First.", {
                        position: "bottom-right",
                    })
                }
                if (!values.helpCompanies || !values.helpCompanies.trim()) {
                    return toast.error("I Help Companies Field Is Required.", {
                        position: "bottom-right",
                    })
                }

                if (inputList.length === 1 && (inputList[0].weHelped !== "" || inputList[0].results !== "" || inputList[0].timeLine !== "" || inputList[0].process !== "")) {
                    const result = inputList.map((item) => {
                        const isEmpty = Object.keys(item).length === 4;
                        const allValues = Object.values(item)
                        const containsString = allValues.includes("");
                        return isEmpty && !containsString
                    })

                    let finalResult = allEqual(result)
                    if (finalResult) {
                        return toast.error('Describe Case Studies.', {
                            position: "bottom-right",
                        })
                    }
                }
                if (inputList.length > 1) {
                    const result = inputList.map((item) => {
                        const isEmpty = Object.keys(item).length === 4;
                        const allValues = Object.values(item)
                        const containsString = allValues.includes("");
                        return isEmpty && !containsString
                    })

                    let finalResult = allEqual(result)
                    if (finalResult) {
                        return toast.error('Describe Case Studies.', {
                            position: "bottom-right",
                        })
                    }
                }

                if (inputList.length === 1) {
                    return setSmShow(true)
                }
                else {
                    addCampaignData({
                        variables: {
                            campaignDataInput: {
                                Location: 'india',
                                businessType: values.businessType,
                                campaignId: campaignId,
                                departments: values.whichDepartment,
                                helpCompanies: values.helpCompanies,
                                reachOut: values.reachingOut,
                                sellTo: values.whomSell,
                                sellType: values.whatSell,
                                caseStudy: [...inputList],
                                outReachMethods: [...values.outreachMethods],
                            }
                        }
                    })
                }
            }
            catch (e) {
                console.error(e)
            }
        }
    })

    const handleYes = () => {
        setSmShow(false)
        addCampaignData({
            variables: {
                campaignDataInput: {
                    Location: 'india',
                    businessType: formik.values.businessType,
                    campaignId: campaignId,
                    departments: formik.values.whichDepartment,
                    helpCompanies: formik.values.helpCompanies,
                    reachOut: formik.values.reachingOut,
                    sellTo: formik.values.whomSell,
                    sellType: formik.values.whatSell,
                    caseStudy: [...inputList],
                    outReachMethods: [...formik.values.outreachMethods],
                }
            }
        })
    }

    const countCharsTextArea = () => {
        document.getElementById("charNumTextArea").innerHTML = formik.values.helpCompanies.length + ' / 1000';
    }


    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
    };

    // handle click event of the Remove button
    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        setInputList([...inputList, { weHelped: "", results: "", timeLine: "", process: "" }]);
    };


    if (errorMessage) {
        toast.error(errorMessage, {
            position: "bottom-right",
        })
        setErrorMessage('')
    }

    if (addCampaignDataSuccess) {
        toast.success("Campaign Data Saved.", {
            position: "bottom-right",
        })
        formik.resetForm()
        // setValue("")
        setInputList([{ weHelped: "", results: "", timeLine: "", process: "" }])
        setAddCampaignData(false)
        history.push(`/campaigns/campaign-details/${campaignId}`)
    }

    if (profileLoading) {
        return <div className="spinner" >
            <Loaders
                type="ThreeDots"
                color="#192f60"
                height={70}
                width={70}
                timeout={3000}
            />
        </div>
    }

    return (
        <>
            <div className='create-campaign-screen'>
                <div className="back-btn-div">
                    <Link to='/dashboard'>
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.75" d="M0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538407 6.65686 0.928931L0.292893 7.29289ZM17 7L1 7L1 9L17 9L17 7Z" fill="#0A1E43" />
                        </svg>
                        Back to dashboard
                    </Link>
                </div>
                <div className='create-title'>
                    <h4>Auto generate script</h4>
                </div>
                <div className='campiagn-form-wrap'>
                    <Form className="campaignForm" onSubmit={formik.handleSubmit}>
                        <ul className='campaign-form-steps'>
                            <li className='show-li'>
                                <Form.Group className='input-wrap radio-wrap'>
                                    <Form.Label>What do you sell? *</Form.Label>
                                    <div className="inline-radio">
                                        <Form.Check
                                            id="product"
                                            type="radio"
                                            name="whatSell"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value="Product"
                                            checked={formik.values.whatSell === "Product"}
                                            label={
                                                <>
                                                    <span className='tickmark'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="10" cy="10" r="10" fill="#5FE0A9" />
                                                            <path d="M5 10.0003L7.85714 13.8098L15.4762 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                                        </svg>
                                                    </span>
                                                    <span className='icon-container'>
                                                        <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M21.248 0.000363175C21.143 0.000363175 21.038 0.0179248 20.9508 0.053048L0.695308 6.47227C0.572724 6.50739 0.4677 6.55973 0.380236 6.62964C0.292772 6.69988 0.205307 6.787 0.152971 6.89203C0.0830694 6.97949 0.0303873 7.10208 0.0131712 7.2071C-0.0043904 7.32934 -0.0043904 7.45193 0.0131712 7.55696V36.0503C0.0131712 36.2428 0.0655112 36.4525 0.1881 36.6274C0.3279 36.8023 0.485612 36.9249 0.695317 36.9773L20.8283 43.3618C20.9333 43.3969 21.0384 43.4317 21.1606 43.4492C21.2832 43.4492 21.4054 43.4317 21.5105 43.3969H21.528L41.7836 36.9773C41.9936 36.925 42.151 36.8024 42.2732 36.6274C42.3958 36.4525 42.4833 36.2425 42.4833 36.0503V7.41684C42.4833 7.39927 42.4657 7.38171 42.4657 7.38171V7.36415C42.4657 7.24157 42.4481 7.13689 42.3958 7.03186C42.3607 6.92684 42.2908 6.82181 42.2209 6.73435C42.151 6.64689 42.0635 6.59455 41.9585 6.5243C41.8535 6.47196 41.7484 6.43684 41.6262 6.41928L21.5285 0.0526849C21.441 0.0175616 21.3535 0 21.2485 0L21.248 0.000363175ZM21.2305 2.02962L38.2147 7.41684L21.2305 12.7869L4.24623 7.41684L21.2305 2.02962ZM40.5057 8.74635V35.3162L22.2266 41.106V14.5538L40.5057 8.74644V8.74635Z" fill="#407BFF" />
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M21.2481 4.5479C21.143 4.5479 21.038 4.5479 20.9333 4.58303L15.021 6.48966C14.8984 6.52479 14.7762 6.59469 14.6711 6.68215C14.5837 6.75205 14.4962 6.85708 14.4263 6.97966C14.374 7.10225 14.3388 7.22449 14.3213 7.34708C14.3213 7.48688 14.3213 7.60947 14.3736 7.73206C14.4088 7.85464 14.4787 7.97688 14.5661 8.08192C14.636 8.16938 14.741 8.25684 14.8636 8.32674C14.9862 8.37908 15.1085 8.4142 15.2486 8.4142C15.3712 8.43177 15.511 8.4142 15.6336 8.37908L21.2484 6.55989L23.9071 7.41696L20.9509 8.36151C20.8111 8.39663 20.7061 8.46654 20.601 8.554C20.496 8.64146 20.4261 8.72893 20.3562 8.85151C20.3039 8.9741 20.2688 9.09634 20.2512 9.21893C20.2512 9.35873 20.2512 9.48132 20.3035 9.60391C20.3387 9.72649 20.4086 9.84873 20.4785 9.95376C20.5659 10.0412 20.671 10.1287 20.7932 10.181C20.8982 10.2509 21.038 10.2861 21.1606 10.2861C21.2832 10.3036 21.423 10.2861 21.5456 10.2509L27.4576 8.34429C27.6676 8.29195 27.8426 8.1518 27.9648 7.99443C28.0874 7.81951 28.1397 7.60946 28.1397 7.39975C28.1397 7.18971 28.0874 6.99756 27.9648 6.82263C27.8422 6.6477 27.6501 6.52512 27.4576 6.47277L21.5456 4.58297C21.4406 4.56541 21.3531 4.54785 21.2481 4.54785L21.2481 4.5479Z" fill="#407BFF" />
                                                        </svg>
                                                    </span>
                                                    <span className='label-title'>Product (SaaS)</span>
                                                </>
                                            }
                                        />

                                        <Form.Check
                                            id="service"
                                            type="radio"
                                            name="whatSell"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value="Service"
                                            checked={formik.values.whatSell === "Service"}
                                            label={
                                                <>
                                                    <span className='tickmark'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="10" cy="10" r="10" fill="#5FE0A9" />
                                                            <path d="M5 10.0003L7.85714 13.8098L15.4762 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                                        </svg>
                                                    </span>
                                                    <span className='icon-container'>
                                                        <svg width="37" height="41" viewBox="0 0 37 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M33.4606 28.1386C32.4043 28.5187 30.7144 28.9835 28.8553 29.4062C28.1792 30.5046 26.9541 31.3919 25.0529 31.7721C24.5881 31.8567 24.1233 31.8989 23.5739 31.8989C22.2642 31.941 20.701 31.8143 18.9687 31.6454C18.8419 31.6454 18.7152 31.6454 18.6306 31.6033C18.208 31.5611 17.8278 31.2652 17.8278 30.8429C17.7856 30.2935 18.208 29.8712 18.7573 29.9134C18.884 29.9134 19.0108 29.9555 19.1799 29.9555C21.4192 30.1668 23.4896 30.3357 24.8415 30.0822C27.292 29.6175 28.0103 28.1386 27.8414 26.8713C27.7147 25.8572 26.954 24.8433 25.7289 24.97C23.9965 25.0968 21.9686 24.97 20.0249 24.8012C17.7856 24.6323 15.4618 24.5899 13.814 24.759C11.9974 24.9703 8.2792 26.3222 4.98356 28.5615C3.37795 29.6599 1.60342 30.9699 0.505045 31.7303C-0.0443063 32.1529 -0.171036 32.9133 0.251586 33.4626L4.94113 39.6729C5.36376 40.2223 6.12415 40.3065 6.63101 39.8842L8.40555 38.532C8.82818 38.194 9.37724 38.1094 9.88448 38.2786C13.0955 39.2927 16.518 39.9685 18.7572 40.0952C23.6583 40.3487 33.0379 34.5604 35.742 32.7013C38.4036 30.8001 36.4599 27.0398 33.4603 28.1384L33.4606 28.1386Z" fill="#C9CCCE" />
                                                            <path d="M13.011 13.4777H14.7434C14.9547 14.1959 15.2082 14.872 15.5883 15.5057L14.3629 16.6887C14.067 16.9846 14.067 17.4491 14.3629 17.745L16.6868 20.0689C16.9827 20.3648 17.4472 20.3648 17.7431 20.0689L18.9682 18.8437C19.6018 19.1818 20.2779 19.4774 20.9962 19.6887V21.3786C20.9962 21.8012 21.3342 22.1389 21.7565 22.1389H25.0099C25.4325 22.1389 25.7703 21.8009 25.7703 21.3786V19.6462C26.4885 19.4349 27.1645 19.1814 27.7982 18.8013L28.9813 20.0264C29.2772 20.3223 29.7416 20.3223 30.0375 20.0264L32.3614 17.7025C32.6573 17.4066 32.6573 16.9421 32.3614 16.6462L31.1366 15.4635C31.4746 14.8299 31.7702 14.1538 31.9815 13.4355H33.6714C34.094 13.4355 34.4318 13.0975 34.4318 12.6752V9.42179C34.4318 8.99916 34.0937 8.66143 33.6714 8.66143H31.939C31.7277 7.9432 31.4743 7.26715 31.0941 6.63346L32.3192 5.40834C32.6151 5.11244 32.6151 4.64797 32.3192 4.35206L29.9954 2.02819C29.6995 1.73229 29.235 1.73229 28.9391 2.02819L27.7564 3.29519C27.1227 2.95714 26.4467 2.66155 25.7284 2.45025V0.760365C25.7284 0.337735 25.3904 0 24.968 0H21.7146C21.292 0 20.9543 0.338045 20.9543 0.760365V2.49273C20.236 2.70404 19.56 2.9575 18.9263 3.33767L17.7012 2.15464C17.4053 1.85874 16.9408 1.85874 16.6449 2.15464L14.321 4.47852C14.0251 4.77441 14.0251 5.23888 14.321 5.53479L15.5462 6.75991C15.2081 7.39355 14.9125 8.06961 14.7012 8.78788H13.0113C12.5887 8.78788 12.251 9.12592 12.251 9.54824V12.8016C12.2504 13.1397 12.5884 13.4777 13.011 13.4777V13.4777ZM23.3202 5.53456C26.3623 5.53456 28.855 8.02728 28.855 11.0693C28.855 14.1114 26.3623 16.6041 23.3202 16.6041C20.2782 16.6041 17.7855 14.1114 17.7855 11.0693C17.7855 8.02728 20.2782 5.53456 23.3202 5.53456Z" fill="#C9CCCE" />
                                                            <path d="M21.8834 13.4359C22.0523 13.6472 22.306 13.7318 22.6016 13.7318C22.8551 13.7318 23.1085 13.605 23.3198 13.4359L26.4886 10.0136C26.8688 9.63342 26.8267 8.99951 26.4465 8.66143C26.0663 8.28124 25.4324 8.32338 25.0943 8.70357L22.6438 11.3655L21.6721 10.3092C21.2919 9.92899 20.7004 9.88655 20.3199 10.267C19.9397 10.6472 19.8973 11.2387 20.2778 11.6192L21.8834 13.4359Z" fill="#C9CCCE" />
                                                        </svg>
                                                    </span>
                                                    <span className='label-title'>Service (Agency)</span>
                                                </>
                                            }
                                        />
                                    </div>
                                    {formik.errors.whatSell && formik.touched.whatSell && (
                                        <div className="input-feedback">{formik.errors.whatSell}</div>
                                    )}
                                </Form.Group>

                                <div className='hover_container' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                You need to choose whether you are selling a product or a service to the prospects. A product is a tangible item that can be reused for a certain period of time. A service, on the other hand, is a transaction where no physical goods are involved.
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap' controlId="whomSell">
                                    <Form.Label>Whom do you sell to? *</Form.Label>
                                    <Form.Select
                                        name="whomSell"
                                        aria-label="Default select example"
                                        value={formik.values.whomSell}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" disabled >Select</option>
                                        {
                                            sellToList && sellToList.length > 0 && sellToList.map((item, i) => (
                                                <option value={item} key={i} >{item}</option>
                                            ))
                                        }
                                    </Form.Select>
                                    {formik.errors.whomSell && formik.touched.whomSell && (
                                        <div className="input-feedback">{formik.errors.whomSell}</div>
                                    )}
                                </Form.Group>

                                <div className='hover_container' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                The business that you think is your customer. Choose small businesses (for under $2M) to mid-market ($2M to $10M) enterprise ($10M+)
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap' controlId="reachingOut">
                                    <Form.Label>Who are you reaching out to? *</Form.Label>
                                    <Form.Select
                                        name="reachingOut"
                                        aria-label="Default select example"
                                        value={formik.values.reachingOut}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" disabled >Select</option>
                                        {
                                            reachOutList && reachOutList.length > 0 && reachOutList.map((item, i) => (
                                                <option value={item} key={i} >{item}</option>
                                            ))
                                        }
                                    </Form.Select>
                                    {formik.errors.reachingOut && formik.touched.reachingOut && (
                                        <div className="input-feedback">{formik.errors.reachingOut}</div>
                                    )}
                                </Form.Group>
                                <div className='hover_container' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                You need to select the designation of the person you are reaching out to, from C-level to Manager.
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap' controlId="whichDepartment">
                                    <Form.Label>Which  Department? *</Form.Label>
                                    <Form.Select
                                        name="whichDepartment"
                                        aria-label="Default select example"
                                        value={formik.values.whichDepartment}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" disabled >Select</option>
                                        {
                                            departmentsList && departmentsList.length > 0 && departmentsList.map((item, i) => (
                                                <option value={item} key={i} >{item}</option>
                                            ))
                                        }
                                    </Form.Select>

                                    {formik.errors.whichDepartment && formik.touched.whichDepartment && (
                                        <div className="input-feedback">{formik.errors.whichDepartment}</div>
                                    )}
                                </Form.Group>
                                <div className='hover_container' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                Select the department you are reaching out to from the drop-down menu.
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap' controlId="businessType">
                                    <Form.Label>Business Type? *</Form.Label>
                                    <Form.Select
                                        name="businessType"
                                        aria-label="Default select example"
                                        value={formik.values.businessType}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" disabled >Select</option>
                                        {
                                            businessTypeList && businessTypeList.length > 0 && businessTypeList.map((item, i) => (
                                                <option value={item} key={i} >{item}</option>
                                            ))
                                        }
                                    </Form.Select>
                                    {formik.errors.businessType && formik.touched.businessType && (
                                        <div className="input-feedback">{formik.errors.businessType}</div>
                                    )}
                                </Form.Group>
                                <div className='hover_container' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                Select the type of business or industry you intend to reach out to.
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap outreach-method'>
                                    <Form.Label>Outreach Methods? *</Form.Label>
                                    <div className='inline-checkbox'>
                                        {outreachMethods.map((tag) => (
                                            <div key={tag}>
                                                <Form.Check
                                                    inline
                                                    // defaultChecked={tag==='Email'? true : false}
                                                    disabled={tag === 'Email' ? true : false}
                                                    id={tag}
                                                    type="checkbox"
                                                    name={tag}
                                                    checked={tag === 'Email' ? true : formik.values.outreachMethods.includes(tag)}
                                                    onChange={handleChange}
                                                    label={tag}
                                                />
                                            </div>
                                        ))}

                                    </div>
                                    {
                                        textProvider ? "" :
                                            <span>Connect your SMS provider by clicking on this
                                                <Link to="/settings/text-provider">link</Link>.
                                            </span>
                                    }
                                </Form.Group>
                                <div className='hover_container' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                You need to select your method of reaching out to customers - email or text on mobile. You can choose both as well.
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap textarea-wrap' controlId="helpCompanies">
                                    <Form.Label>I help companies *</Form.Label>
                                    {/* <Form.Text id="helpCompaniesHelpBlock" muted>
                                        Ex : I help companies generating more leads
                                    </Form.Text> */}
                                    <Form.Control
                                        name="helpCompanies"
                                        // as="textarea"
                                        type="text"
                                        // rows={5}
                                        aria-describedby="helpCompaniesHelpBlock"
                                        maxLength="1000"
                                        onKeyUp={countCharsTextArea}
                                        value={formik.values.helpCompanies}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
                                    />
                                    <div>
                                        <span>Ex : I help companies generating more leads</span>
                                    </div> &nbsp; 
                                    {formik.errors.helpCompanies && formik.touched.helpCompanies && (
                                        <div className="input-feedback" style={{ marginTop: '36px', marginLeft: '-53%' }} >{formik.errors.helpCompanies}</div>
                                    )}
                                    <span id="charNumTextArea">0 / 1000</span>
                                </Form.Group>
                            </li>
                            <li className='show-li'>
                                <Form.Group className='input-wrap case-studies'>
                                    <Form.Label>Please add Case Studies</Form.Label>
                                    <p>Add case study to generate scripts for your campaign. (should contain
                                        Company name, result, timeline, and process)</p>
                                    <span>Ex: We helped Sony (company name) increase sales by 150% (results) in a week
                                        (timeline) using automated outbound campaigns (process)</span>
                                    {inputList.map((x, i) => {
                                        return (
                                            <div key={i} className="box">
                                                <div className="box-inner">
                                                    <p className='box-title'>
                                                        Case Study {i + 1}
                                                        {inputList.length > 1 && <button
                                                            className="mr10"
                                                            onClick={() => handleRemoveClick(i)}>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="#206FFD" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M10.1004 5.90039L5.90039 10.1004" stroke="#206FFD" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M5.90039 5.90039L10.1004 10.1004" stroke="#206FFD" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </button>
                                                        }
                                                    </p>
                                                    <Form.Group controlId="weHelped">
                                                        <Form.Label>We Helped</Form.Label>
                                                        <Form.Control
                                                            name="weHelped"
                                                            type="text"
                                                            placeholder=""
                                                            value={x.weHelped}
                                                            onChange={e => { handleInputChange(e, i) }}
                                                            onBlur={formik.handleBlur}
                                                            style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
                                                        />
                                                        <span>Ex : SyndicationPro</span>
                                                        {formik.errors.weHelped && formik.touched.weHelped && (
                                                            <div className="input-feedback">{formik.errors.weHelped}</div>
                                                        )}
                                                    </Form.Group>
                                                    <Form.Group controlId="results">
                                                        <Form.Label>Results</Form.Label>
                                                        <Form.Control
                                                            name="results"
                                                            type="text"
                                                            placeholder=""
                                                            value={x.results}
                                                            onChange={e => handleInputChange(e, i)}
                                                            onBlur={formik.handleBlur}
                                                            style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
                                                        />
                                                        <span>Ex : Increase sales by 150%</span>
                                                    </Form.Group>
                                                    <Form.Group controlId="timeLine">
                                                        <Form.Label>Timeline</Form.Label>
                                                        <Form.Control
                                                            name="timeLine"
                                                            type="text"
                                                            placeholder=""
                                                            value={x.timeLine}
                                                            onChange={e => handleInputChange(e, i)}
                                                            onBlur={formik.handleBlur}
                                                            style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
                                                        />
                                                        <span>Ex : In a week</span>
                                                    </Form.Group>
                                                    <Form.Group controlId="process">
                                                        <Form.Label>Process</Form.Label>
                                                        <Form.Control
                                                            name="process"
                                                            type="text"
                                                            placeholder=""
                                                            value={x.process}
                                                            onChange={e => handleInputChange(e, i)}
                                                            onBlur={formik.handleBlur}
                                                            style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
                                                        />
                                                        <span>Ex : using automated outbound campaigns</span>
                                                    </Form.Group>
                                                </div>
                                                <div className="btn-box">
                                                    {inputList.length - 1 === i && inputList.length < 5 && <button className="solid-button" onClick={handleAddClick}>Add Case Study</button>}
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {/* <div>
                                        <span>Warning! While OmniOutreach can generate scripts without case studies, cold emails without case studies drastically underperform emails that show examples of past results.</span>
                                    </div> */}
                                </Form.Group>
                                <div className='hover_container_caseStudy' >
                                    <OverlayTrigger
                                        key='bottom'
                                        placement='bottom'
                                        overlay={
                                            <Tooltip id={`tooltip-bottom`}>
                                                You need to add details of the companies that you worked with to help us draft the campaigns. Make sure you add the company name, results achieved, timeline, and the process.
                                            </Tooltip>
                                        }
                                    >
                                        <img src={Question} className="questImg" alt="Question" />
                                    </OverlayTrigger>
                                </div>
                            </li>
                        </ul>
                        {
                            loading ?
                                <Button className='solid-button' >Generate Your Scripts &nbsp;
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </Button>
                                :
                                <Button className='solid-button' type="submit" >Generate Your Scripts</Button>
                        }
                    </Form>
                </div>
            </div>

            <Modal
                size="md"
                className='warning-modal'
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className='warning-div'>
                        <img src={warningIcon} alt="warning" />
                        <h2>Warning</h2>
                        <p>While OmniOutreach can generate scripts without case studies, cold emails without case studies drastically underperform emails that show examples of past results. Are you sure you want to continue?
                        </p>
                        <div className='btn-container'>
                            <button className='cancel-btn' onClick={() => setSmShow(false)}>No</button>
                            <button className='solid-button' style={{ flex: "0 0 128px" }} onClick={handleYes} >
                                Yes
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default withRouter(CampaignAutoScript)
